export enum GaTrackingEventAction {
  CheckoutErrors = 'Checkout Errors',
  ExtendedCheckout = 'Extended Checkout',
  AddToCartMoreThanInStock = 'More than in Stock Click',
  FlixMediaContentView = 'Flixmedia content View',
  FlixMediaContentScrolling = 'Flixmedia content scrolled',
  FlixMediaContentFailed = 'Flixmedia content Failed',
  FlixMediaBrandPageView = 'Flixmedia content View',
  FlixMediaFailed = 'Flixmedia failed',
  CartNotifications = 'Cart Notifications',
  OrderHistorySideMenu = 'mm_account_side_bar_clicked',
  BuyAgainHeader = 'buy again header link clicked',
  ApprovalDashboardHeader = 'approvals header link clicked',
  ShoppingListHeader = 'shopping list header link clicked',
  YourAssortmentHeader = 'your assortment header link clicked',
  OrdersHistoryHeaderLinkClick = 'order_history_header_link_clicked',
  PromoView = 'Content Carousel View',
  SelectPromotion = 'Content Carousel Click',
  NavigationClick = 'Navigation Bar Click',
  CheckoutNotifications = 'Checkout Notifications',
  productCarouselTeaserClick = 'Product Carousel Teaser Click',
  categoryFilter = 'category_filter',
  ShoppingListShowMoreProducts = 'sl_show_more_products',
  ProductNotShown = 'product_not_shown',
  ChangeProductQuantity = 'change_product_quantity',
  FilterAreaInteraction = 'filter_area_interaction',
  SearchBarFocused = 'using_search_bar',
  ZeroSearchedResults = 'search_zero_result',
  Search = 'search',
  PLP_CATEGORY_NAVIGATION_VIEWED = 'plp_category_navigation_viewed',
  PLP_CATEGORY_NAVIGATION_EXPANDED = 'plp_category_navigation_expanded',
  PLP_CATEGORY_NAVIGATION_COLLAPSED = 'plp_category_navigation_collapsed',
  PLP_CATEGORY_NAVIGATION = 'plp_category_navigation',
  HEADLINE_BANNER_VIEWED = 'headline_banner_viewed',
  USP_BENEFITS_VIEWED = 'benefits_viewed',
  BEST_SELLING_BRANDS_VIEWED = 'best_selling_brands_viewed',
  BEST_SELLING_BRANDS_CLICKED = 'best_selling_brands_clicked',
  NEWSLETTER_VIEWED = 'newsletter_viewed',
  NEWSLETTER_SUSCRIPTION = 'newsletter_subscription',
  SEE_OFFERS = 'see_offers',
  POPULAR_LINKS_VIEWED = 'popular_categories_viewed',
  RELATED_CATEGORIES_VIEWED = 'related_categories_viewed',
  POPULAR_LINKS_CLICKED = 'popular_categories_clicked',
  RELATED_CATEGORIES_CLICKED = 'related_categories_clicked',
  POPULAR_LINKS_SHOW_MORE = 'popular_categories_show_more',
  POPULAR_LINKS_SHOW_LESS = 'popular_categories_show_less',
  LOCATION_TOGGLER = 'location_toggler',
  HOVER_IMAGE_SEARCH = 'hover_image_search',
  IMAGE_SEARCH_LOGO_CLICKED = 'image_search_logo_clicked',
}
